import React from 'react';
import { cn } from '../../lib/cn';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}
export function Card({
  children,
  className,
  as: Tag = 'div'
}: CardProps) {
  return <Tag className={cn('rounded-xl border border-slate-200 bg-white shadow-card', className)} data-id="element-405" data-mp="8adk9heajhny">
      {children}
    </Tag>;
}
interface CardHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}
export function CardHeader({
  title,
  subtitle,
  action,
  icon,
  className
}: CardHeaderProps) {
  return <div className={cn('flex items-start justify-between gap-4 px-5 pt-4', className)} data-id="element-406" data-mp="r0d7rzuhgop9">
      <div className="flex items-start gap-3 min-w-0" data-id="element-407" data-mp="w0rbj5p1xchh">
        {icon && <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-600" data-id="element-408" data-mp="2sv48feam07js">
            {icon}
          </div>}
        <div className="min-w-0" data-id="element-409" data-mp="2zhlbjh9dkq90">
          <h3 className="text-sm font-semibold text-slate-900 truncate" data-id="element-410" data-mp="2zinzphfbcel8">{title}</h3>
          {subtitle && <p className="text-xs text-slate-500 mt-0.5" data-id="element-411" data-mp="2upl6jaeg775k">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="shrink-0" data-id="element-412" data-mp="2prtb46elh2wm">{action}</div>}
    </div>;
}